// extracted by mini-css-extract-plugin
module.exports = {"bubble":"UserErrorMessage_bubble__ADVOO","description":"UserErrorMessage_description__H4IOr"};